/**
 * PostHog Analytics Event Names
 */

export enum PostHogEventName {
  // Signup Flow Events
  SIGNUP_FLOW_SIGNUP_PAGE_VIEWED = 'signup_flow:signup_page_viewed',
  SIGNUP_FLOW_SIGNUP_SUBMITTED = 'signup_flow:signup_submitted',
  SIGNUP_FLOW_EMAIL_CONFIRMED = 'signup_flow:email_confirmed',
  SIGNUP_FLOW_DASHBOARD_VIEWED = 'signup_flow:dashboard_viewed',

  // Onboarding Tour Events
  ONBOARDING_TUTORIAL_STARTED = 'onboarding:tutorial_started',
  ONBOARDING_TUTORIAL_FINISHED = 'onboarding:tutorial_finished',
  ONBOARDING_TUTORIAL_SKIPPED = 'onboarding:tutorial_skipped',

  // Onboarding Flow Events
  ONBOARDING_TESTMAIL_SENT = 'onboarding:testmail_sent',
  ONBOARDING_WORKSPACE_SETUP_STARTED = 'onboarding:workspace_setup_started',
  ONBOARDING_CONNECT_KLAVIYO_CLICKED = 'onboarding:connect_klaviyo_clicked',
  ONBOARDING_KLAVIYO_SETUP_FINISHED = 'onboarding:klaviyo_setup_finished',
  ONBOARDING_ENABLE_SHOPIFY_CLICKED = 'onboarding:enable_shopify_clicked',
  ONBOARDING_CONNECT_SHOPIFY_CLICKED = 'onboarding:connect_shopify_clicked',
  ONBOARDING_SHOPIFY_SETUP_FINISHED = 'onboarding:shopify_setup_finished',
  ONBOARDING_WORKSPACE_SETUP_FINISHED = 'onboarding:workspace_setup_finished',
  ONBOARDING_BILLING_SETUP_STARTED = 'onboarding:billing_setup_started',
  ONBOARDING_BILLING_SETUP_FINISHED = 'onboarding:billing_setup_finished',
  ONBOARDING_BOOK_NOW_CLICKED = 'onboarding:book_now_clicked',
  ONBOARDING_TALK_TO_US_CLICKED = 'onboarding:talk_to_us_clicked',
  ONBOARDING_CALL_PAGE_OPENED = 'onboarding:call_page_opened',
  ONBOARDING_KICKOFF_CALL_BOOKED = 'onboarding:kickoff_call_booked',

  // Onboarding Checklist Events
  ONBOARDING_CHECKLIST_INTRO_VIDEO_WATCHED = 'onboarding:checklist_intro_video_watched',
  ONBOARDING_CHECKLIST_FORM_CREATED = 'onboarding:checklist_form_created',
  ONBOARDING_CHECKLIST_TEST_EMAIL_SENT = 'onboarding:checklist_test_email_sent',
  ONBOARDING_CHECKLIST_TEMPLATE_IMPORTED = 'onboarding:checklist_template_imported',
  ONBOARDING_CHECKLIST_FORM_ADDED_TO_EMAIL = 'onboarding:checklist_form_added_to_email',
  ONBOARDING_CHECKLIST_EMAIL_EXPORTED = 'onboarding:checklist_email_exported',

  // Onboarding Wizard Events
  ONBOARDING_WIZARD_STARTED = 'onboarding:wizard_started',
  ONBOARDING_WIZARD_STEP_COMPLETED = 'onboarding:wizard_step_completed',
  ONBOARDING_WIZARD_USER_TYPE_SELECTED = 'onboarding:wizard_user_type_selected',
  ONBOARDING_WIZARD_SHOP_URL_SUBMITTED = 'onboarding:wizard_shop_url_submitted',
  ONBOARDING_WIZARD_USE_CASES_SELECTED = 'onboarding:wizard_use_cases_selected',
  ONBOARDING_WIZARD_ESP_SELECTED = 'onboarding:wizard_esp_selected',
  ONBOARDING_WIZARD_KLAVIYO_CONNECTED = 'onboarding:wizard_klaviyo_connected',
  ONBOARDING_WIZARD_AI_FORM_GENERATED = 'onboarding:wizard_ai_form_generated',
  ONBOARDING_WIZARD_COMPLETED = 'onboarding:wizard_completed',
  ONBOARDING_WIZARD_SKIPPED = 'onboarding:wizard_skipped',

  // Builder Events
  BUILDER_TESTMAIL_SENT = 'builder:testmail_sent',
  BUILDER_TEMPLATE_OPENED = 'builder:template_opened',
  BUILDER_COMPONENT_ADDED = 'builder:component_added',
  BUILDER_PREVIEW_OPENED = 'builder:preview_opened',
  BUILDER_PUSH_TO_KLAVIYO_CLICKED = 'builder:push_to_klaviyo_clicked',
  BUILDER_PUSH_TO_KLAVIYO_SUCCESS = 'builder:push_to_klaviyo_success',
  BUILDER_PUSH_TO_KLAVIYO_FAILED = 'builder:push_to_klaviyo_failed',
  BUILDER_OPENED = 'builder:opened',
  BUILDER_PREVIEW_BUTTON_CLICKED = 'builder:preview_button_clicked', // legacy - use BUILDER_PREVIEW_OPENED

  // Templates Events
  TEMPLATES_COMPLETE_SETUP_CLICKED = 'templates:complete_setup_clicked',
  TEMPLATES_IMPORT_TEMPLATES_CLICKED = 'templates:import_templates_clicked',
  TEMPLATES_EDIT_TEMPLATE_CLICKED = 'templates:edit_template_clicked',
  TEMPLATES_DELETE_TEMPLATE_CLICKED = 'templates:delete_template_clicked',

  // Countdown Events
  COUNTDOWN_NEW_TIMER_CLICKED = 'countdown:new_timer_clicked',
  COUNTDOWN_SAVE_CLICKED = 'countdown:save_clicked',
  COUNTDOWN_UPDATE_CLICKED = 'countdown:update_clicked',
  COUNTDOWN_EXPORT_CLICKED = 'countdown:export_clicked',

  // Forms Events
  FORMS_CREATE_FORM_CLICKED = 'forms:create_form_clicked',
  FORMS_EMBED_CODE_COPIED = 'forms:embed_code_copied',
  FORMS_PUBLISHED = 'forms:published',
  FORMS_DELETED = 'forms:deleted',

  // Settings Events
  SETTINGS_UPDATED = 'settings_updated',
  SETTINGS_VIEW_PLANS_CLICKED = 'settings:view_plans_clicked',
  SETTINGS_UPGRADE_PLAN_CLICKED = 'settings:upgrade_plan_clicked',
  SETTINGS_PLAN_BOOKED = 'settings:plan_booked',
  SETTINGS_TEAM_INVITE_SENT = 'settings:team_invite_sent',
  SETTINGS_TEAM_INVITE_ACCEPTED = 'settings:team_invite_accepted',
  SETTINGS_CREATE_WORKSPACE_CLICKED = 'settings:create_workspace_clicked',
  SETTINGS_WORKSPACE_CREATED = 'settings:workspace_created',

  // Integration Events
  INTEGRATION_KLAVIYO_DISCONNECTED = 'integration:klaviyo_disconnected',
  INTEGRATION_SHOPIFY_DISCONNECTED = 'integration:shopify_disconnected',

  // Admin Events
  ADMIN_AGENCY_REQUEST_APPROVED = 'backend:agency_request_approved',

  // Image Picker Events
  IMAGE_AI_GENERATED = 'image:ai_generated',
  IMAGE_STOCK_SEARCHED = 'image:stock_searched',
  IMAGE_STOCK_SELECTED = 'image:stock_selected',

  // Docs Panel Events
  DOCS_PANEL_OPENED = 'docs:panel_opened',
  DOCS_PANEL_CLOSED = 'docs:panel_closed',
  DOCS_PANEL_PAGE_CHANGED = 'docs:page_changed',

  // Reporting Events
  REPORTING_MONTHLY_RESPONSE_COUNT_UPDATED = 'reporting:monthly_response_count_updated',

  // Changelog Events
  CHANGELOG_SHOWN = 'changelog:shown',
  CHANGELOG_PAGE_NAVIGATED = 'changelog:page_navigated',
  CHANGELOG_DISMISSED = 'changelog:dismissed',
}



